import { DashboardWrapper } from "../../../containers/dashboard/DashboardWrapper";
import { LayoutOutlet } from "../../../containers/dashboard/LayoutWrapper";
import { USER_ROLES } from "../../../utils/constants";
import { useAuth } from "../../../zustand/auth.store";

interface IProfileRole {
  roleType: USER_ROLES;
}
export const AdminLayout = () => {
  const userRole = useAuth.getState().profile! as IProfileRole;
  return (
    <DashboardWrapper
      sidebar={sidebar(userRole?.roleType ?? USER_ROLES.IBILE_ADMIN)}
    >
      <LayoutOutlet />
    </DashboardWrapper>
  );
};

const userRoleSidebars = {
  [USER_ROLES.IBILE_ADMIN]: [
    { name: "Dashboard", path: "/dashboard", iconName: "dashboard" },
    {
      name: "Consultants",
      path: "/consultants",
      iconName: "customers",
    },
    {
      name: "Tax Collection",
      path: "/tax-collection",
      iconName: "reconciliation",
    },
    { name: "Settlements", path: "/settlement", iconName: "cash" },
    { name: "Agents", path: "/agents", iconName: "team" },
    { name: "Change Password", path: "/change-password", iconName: "team" },
  ],
  [USER_ROLES.IBILE_AMBASSADOR]: [
    { name: "Dashboard", path: "/dashboard", iconName: "dashboard" },
    //  / {
    //     name: "Account",
    //     path: "/account",
    //     iconName: "hubs",
    //   },
    {
      name: "Tax Collection",
      path: "/tax-collection",
      iconName: "reconciliation",
    },
    {
      name: "Transaction Funding",
      path: "/transaction-funding",
      iconName: "reconciliation",
    },
    { name: "Agents", path: "/agents", iconName: "team" },
    { name: "Change Password", path: "/change-password", iconName: "team" },
  ],
  [USER_ROLES.IBILE_AGENT]: [
    { name: "Dashboard", path: "/dashboard", iconName: "dashboard" },
    {
      name: "Transactions",
      path: "/agent-transactions",
      iconName: "hubs",
    },
    { name: "Change Password", path: "/change-password", iconName: "team" },
    {
      name: "Transaction Funding",
      path: "/transaction-funding",
      iconName: "reconciliation",
    },
  ],
  [USER_ROLES.PC_LIRS_AGENT]: [
    { name: "Dashboard", path: "/dashboard", iconName: "dashboard" },
    {
      name: "Transactions",
      path: "/agent-transactions",
      iconName: "hubs",
    },
    { name: "Change Password", path: "/change-password", iconName: "team" },
    {
      name: "Transaction Funding",
      path: "/transaction-funding",
      iconName: "reconciliation",
    },
  ],
};

export const sidebar = (userRole: USER_ROLES) => {
  return userRoleSidebars[userRole];
};
